import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import TaskRow from './row';

function TasksTable({ canRequirePlaybookTasks, selectedTaskIds, tasks, onSelectAll, onSelectTask }) {
  const headers = [
    <th key="name" >Name</th>,
    ...(canRequirePlaybookTasks ? [<th key="required" >Required</th>] : []),
    <th key="assignee" >Assignee</th>,
    <th key="dueDate" >Due Date</th>,
  ];

  return (
    <SelectableRecordTable
      className="copy-tasks-table mt-4"
      columnHeaders={headers}
      hasSelectAll
      responsive={false}
      selectAllChecked={selectedTaskIds.length === tasks.length}
      onSelectAllToggle={onSelectAll}
    >
      {tasks.map((task, i) => (
        <TaskRow
          canRequirePlaybookTasks={canRequirePlaybookTasks}
          key={i}
          selectedTaskIds={selectedTaskIds}
          task={task}
          onSelectTask={onSelectTask}
        />
      ))}
    </SelectableRecordTable>
  );
}

TasksTable.propTypes = {
  canRequirePlaybookTasks: PropTypes.bool,
  selectedTaskIds: PropTypes.array.isRequired,
  tasks: PropTypes.array.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onSelectTask: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  canRequirePlaybookTasks: state.canRequirePlaybookTasks,
});

export default connect(mapStateToProps)(TasksTable);